@if (loading()) {
	<section tuiContent>
		<div class="padding-v-8">
			<tui-loader size="l" />
		</div>
	</section>
} @else if (chemical(); as chemical) {
	<section tuiContent>
		<!-- REI Expires At -->
		<label class="mb-4">
			<ctx-chemical-rei-badge
				[reiDate]="reiDate()"
				size="xl"
				[responsive]="false"
			/>
		</label>

		<!-- Chemical Information -->
		<label class="mb-4">
			<p class="font-bold mt-0 mb-1">
				{{ 'data.chemical' | transloco }}
			</p>
			<p class="m-0">
				{{ chemical.name }}
			</p>
		</label>

		<label class="mb-4">
			<p class="font-bold mt-0 mb-1">
				{{ 'data.active-ingredient' | transloco }}:
			</p>
			<p class="m-0">
				{{ chemical.activeIngredient }}
			</p>
		</label>

		<!-- Chemical Revision -->
		<label class="mb-4">
			<p class="font-bold mt-0 mb-1">
				{{ 'chemical.regulation-number' | transloco }}
			</p>
			<p class="m-0">
				{{
					chemicalRevision()?.regulationNumber ??
						('data.not-provided' | transloco)
				}}
			</p>
		</label>

		<!-- Application Type -->
		<label class="mb-4">
			<p class="font-bold mt-0 mb-1">
				{{ 'chemical.application-type.label' | transloco }}
			</p>
			<p class="m-0">
				{{
					applicationType()?.name ?? ('data.not-provided' | transloco)
				}}
			</p>
		</label>

		<!-- REI Hours -->
		<label class="mb-4">
			<p class="font-bold mt-0 mb-1">
				{{ 'chemical.usage-log.rei-hours' | transloco }}
			</p>
			<p class="m-0">
				{{
					'chemical.usage-log.rei-hours-unit'
						| transloco: { hours: context.data.usageLog.reiHours }
				}}
			</p>
		</label>

		<!-- Location -->
		<label class="mb-4">
			<p class="font-bold mt-0 mb-1">
				{{ 'chemical.usage-log.location' | transloco }}
			</p>
			<p class="m-0">
				{{ context.data.usageLog.location }}
			</p>
		</label>

		@if (canShowInternalNote() && usageLogNote()) {
			<label class="mb-4">
				<p class="font-bold mt-0 mb-1">
					{{ 'chemical.usage-log.note' | transloco }}
				</p>
				<p class="m-0 whitespace-pre-line">
					{{ usageLogNote() }}
				</p>
			</label>
		}

		<!-- Applied At -->
		<label class="mb-4">
			<p class="font-bold mt-0 mb-1">
				{{ 'chemical.usage-log.applied-at' | transloco }}
			</p>
			<p class="m-0">
				@if (appliedAtDate(); as appliedAt) {
					{{ appliedAt | date: 'MMMM d, yyyy hh:mm aa' }}
				} @else {
					{{ 'data.not-provided' | transloco }}
				}
			</p>
		</label>

		<!-- Created By -->
		@if (createdByUser(); as user) {
			<label class="mb-4">
				<p class="font-bold mt-0 mb-1">
					{{ 'data.created-by' | transloco }}
				</p>
				<div class="usage-log-details-dialog__created-by">
					<ctx-avatar size="m" [user]="user" />
					<p class="m-0">
						{{ user | userName }}
					</p>
				</div>
			</label>
		}

		<!-- Crops -->
		<label>
			<p class="font-bold mt-0 mb-2">
				{{
					'chemical.usage-log.crop-count'
						| transloco: { count: crops().length }
				}}
			</p>
			@if (crops().length > 0) {
				<tui-scrollbar class="usage-log-details-dialog__crops-list">
					<div class="usage-log-details-dialog__crops-container">
						@for (crop of crops(); track crop.id) {
							<ctx-content-row
								[size]="'s'"
								[content]="crop"
								[asTableRow]="false"
							/>
						}
					</div>
				</tui-scrollbar>
			} @else {
				<p class="m-0 color-tertiary">
					{{ 'chemical.usage-log.crops-empty' | transloco }}
				</p>
			}
		</label>
	</section>
}
